import Vue from "vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
// import style
// import 'swiper/css/swiper.css'
import '~/assets/css/lib/swiper/swiper.css';
import '~/assets/css/lib/swiper/swiper-bundle.min.css';
Vue.use(VueAwesomeSwiper /* { default global options } */);


